var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length > 0
    ? _c(
        "div",
        [
          _c("section-title", {
            attrs: { "has-line": true, title: "Documentos" }
          }),
          _vm._l(_vm.items, function(item, index) {
            return _c("div", { key: `training-document-${index}` }, [
              item.visible
                ? _c(
                    "div",
                    { staticClass: "p-3 ml-3 bg-secondary-3 rounded mb-3" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v("Tipo de Documento:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [_vm._v(" " + _vm._s(item.documentTypeName) + " ")]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col d-flex justify-content-center align-items-center"
                          },
                          [
                            item.isRequired
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "color-secondary-6 font-16 font-weight-normal"
                                  },
                                  [_vm._v(" Requerido ")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              staticClass: "w-100",
                              attrs: {
                                name: "Documento" + index,
                                rules: _vm.required(item)
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-file-input", {
                                          attrs: {
                                            accept: ".pdf",
                                            "attachment-id": item.documentId,
                                            "custom-error-msg":
                                              "Favor anejar un documento.",
                                            disabled: _vm.isReadOnly,
                                            "display-style": "normal",
                                            error: errors[0],
                                            name: item.documentId
                                              ? item.documentName
                                              : ""
                                          },
                                          on: {
                                            "after-remove": () => {
                                              item.documentId = null
                                            }
                                          },
                                          model: {
                                            value: item.file,
                                            callback: function($$v) {
                                              _vm.$set(item, "file", $$v)
                                            },
                                            expression: "item.file"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }